import { useState } from "react";
import StyledTable, { ColumnHeader } from "../../../../components/table/styled-table";
import ProductBatchTableRow from "./product-batch-table-row";
import { ProductBatch } from "../../../../service/model/store.model";
import { configs } from "../../../../app/app-configs";

const headers: ColumnHeader[] = [
    { name: "Received On" },
    { name: "Batch Code" },
    { name: "Unit Cost" },
    { name: "Selling Price" },
    { name: "Quantity Received" },
    { name: "Stock Available" },
    { name: "Expiry Date" },
    { name: "Actions", className: "action-header" }
]

interface TableProps {
    readonly productBatches: ProductBatch[]
}

const ProductBatchTable: React.FC<TableProps> = ({productBatches}) => {
    
    const [page, setPage] = useState(1);

    const pageCount = Math.ceil(productBatches.length / configs.PAGE_SIZE);
    
    const handlePageChange = (selectedPage: number) => {
        setPage(selectedPage);
    }

    return (
        <StyledTable headers={headers}
            currentPage={page}
            totalPages={pageCount}
            onPageChange={handlePageChange}>

            {productBatches?.map(productbatch =>
                <ProductBatchTableRow productBatch={productbatch} key={productbatch.id} />
            )}
        </StyledTable>
    );
}

export default ProductBatchTable;